import type { OtherLocations } from './other';
import OtherLocationsImpl from './otherImpl';

export type { OtherLocations };
export default OtherLocationsImpl;
